import { Injectable } from '@angular/core';
import { TableOfContentData } from '@tiptap-pro/extension-table-of-contents';
import { Editor } from '@tiptap/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TiptapEditorService {
  private readonly editor$$ = new BehaviorSubject<Editor | undefined>(undefined);
  readonly editor$ = this.editor$$.asObservable();

  private readonly tableOfContentData$$ = new BehaviorSubject<TableOfContentData | undefined>(undefined);
  readonly tableOfContentData$ = this.tableOfContentData$$.asObservable();

  private readonly scrollingContainer$$ = new BehaviorSubject<HTMLElement | undefined>(undefined);
  readonly scrollingContainer$ = this.scrollingContainer$$.asObservable();

  registerEditor(editor: Editor) {
    this.editor$$.next(editor);
  }

  registerTableOfContentData(editor: TableOfContentData) {
    this.tableOfContentData$$.next(editor);
  }

  registerScrollingContainer(element: HTMLElement) {
    this.scrollingContainer$$.next(element);
  }
}
